import Button from '@loggi/ui/components/button';
import Col from '@loggi/ui/components/col';
import Textarea from '@loggi/ui/components/textarea';
import icons from '@loggi/ui/components/utils/icons';
import View from '@loggi/ui/components/view';
import { privatePackageTrackerModel } from 'app.models';
import { matchModel } from 'app/app.models';
import getStatusPath from 'app/app.utils';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import UserFeedbackAlert from 'shared/alert/user-feedback-alert/user-feedback-alert.component';
import MainView from 'shared/main-view/main-view.component';
import { SUCCESS } from 'tracker.routes';
import ClassificationHeader from '../classification-header/classification-header.component';
import {
  FEEDBACK_ALERT_PROPS,
  RETRY_MESSAGE
} from '../classification.constants';
import ClassificationService from '../classification.service';
import {
  FINISH_BUTTON_DATA_TEST_ID,
  FINISH_BUTTON_TEXT,
  INSTRUCTIONS_PLACEHOLDER_TEXT
} from './instructions.constants';
import styles from './instructions.styles.scss';

/* eslint-disable react/jsx-props-no-spreading */
export class InstructionsContainer extends Component {
  constructor(props) {
    super(props);

    const instructions = get(
      props,
      'privatePackageTracker.destinationInfo.instructions',
      ''
    );

    this.state = {
      instructions,
      showUserFeedbackAlert: false
    };
  }

  _renderHeader = () => {
    const { history } = this.props;

    const headerProps = {
      onClickBack: history.goBack,
      headerText:
        'Aqui você pode descrever a fachada ou indicar um local próximo.'
    };

    return <ClassificationHeader {...headerProps} />;
  };

  _onChangeInstructions = instructions => {
    this.setState({ instructions });
  };

  _failureMutationCallback = () => {
    this.setState({ showUserFeedbackAlert: true });
  };

  _succesMutationCallback = response => {
    if (!response) {
      // eslint-disable-next-line no-console
      console.error(
        `success mutation callback received ${response} as response.`
      );
      return this._failureMutationCallback();
    }
    const { history } = this.props;
    const queryString = history.location.search;
    if (queryString) {
      return history.push(`${SUCCESS}${queryString}`);
    }
    return history.push(SUCCESS);
  };

  _onSaveInstructions = () => {
    const {
      match: {
        params: { packageId }
      }
    } = this.props;

    const { instructions } = this.state;

    const successCallback = response => this._succesMutationCallback(response);
    const failureCallback = () => this._failureMutationCallback();

    return ClassificationService.send({
      packageId,
      instructions,
      successCallback,
      failureCallback
    });
  };

  _onClickRetry = () => {
    this.setState({ showUserFeedbackAlert: false }, () => {
      return this._onSaveInstructions();
    });
  };

  _getStatusPath() {
    const {
      match: {
        params: { packageId }
      }
    } = this.props;
    return getStatusPath(packageId);
  }

  render() {
    const { privatePackageTracker } = this.props;

    if (!privatePackageTracker) {
      return <Redirect to={this._getStatusPath()} />;
    }

    const { instructions, showUserFeedbackAlert } = this.state;

    const feedbackAlertButtonProps = [
      { value: RETRY_MESSAGE, onClick: this._onClickRetry }
    ];

    return (
      <MainView className="tracker-content classificationMainView">
        {this._renderHeader()}
        <View
          flex
          flexDirection="column"
          flexGrow="1"
          gutter={{
            top: 'double',
            left: 'double',
            right: 'double',
            bottom: 'double'
          }}
          justifyContent="between"
        >
          <Textarea
            placeholder={INSTRUCTIONS_PLACEHOLDER_TEXT}
            onChange={this._onChangeInstructions}
            value={instructions}
            className={styles.instructionsInfo}
          />
          <Col
            flex
            flexDirection="column"
            gutter={{
              top: 'double'
            }}
          >
            <Button
              data-testid={FINISH_BUTTON_DATA_TEST_ID}
              icon={icons.type.CHECK}
              value={FINISH_BUTTON_TEXT}
              onClick={this._onSaveInstructions}
            />
          </Col>
        </View>
        {showUserFeedbackAlert && (
          <UserFeedbackAlert
            {...FEEDBACK_ALERT_PROPS}
            buttonsProps={feedbackAlertButtonProps}
          />
        )}
      </MainView>
    );
  }
}

function mapStateToProps(state) {
  return {
    privatePackageTracker: state.data.privatePackageTracker
  };
}

InstructionsContainer.displayName = 'InstructionsContainer';

InstructionsContainer.propTypes = {
  privatePackageTracker: PropTypes.shape(privatePackageTrackerModel).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string
    }).isRequired,
    goBack: PropTypes.func.isRequired
  }).isRequired,
  match: PropTypes.shape(matchModel).isRequired
};

export default connect(mapStateToProps)(InstructionsContainer);
